import React from "react";
import { Outlet } from "react-router-dom";
import SidebarFinanceiro from "../componentes/Sidebar/SidebarFinanceiro";

function Financeiro() {
  return (
    <div className="flex h-screen">
      <SidebarFinanceiro />
      <div className="flex-grow flex flex-col items-center bg-gray-50">
        <Outlet />
      </div>
    </div>
  );
}

export default Financeiro;
